import {
  HTMLProps,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { orderData, OrderHeaderType } from '../TableTestdata';
import {
  ColumnDef,
  GroupingState,
  Row,
  RowData,
  SortingState,
  TableMeta,
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getExpandedRowModel,
  getGroupedRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';
import * as Styled from '../TableStyled';
import TableConfig from '../TableConfig';
import { useHeaderButtons } from '../../header/HeaderButtonProvider';
import SquareButton from '../../button/SquareButton';
import { AiFillCaretRight } from 'react-icons/ai';
import { AiFillCaretDown } from 'react-icons/ai';
import ListTooltip from '../../common/ListTooltip';
import { ValueWithKey } from '../TableTestdata';
import { traderData } from '../TableTestdata';
import TraderUploadModal from '../../common/modal/ModalComponents/TraderUploadModal';
import axios from 'axios';
import { useTheme } from 'styled-components';
import { toast } from 'react-hot-toast';
import { IoMdArrowDropdown, IoMdArrowUp } from 'react-icons/io';
import { IoMdArrowDropup } from 'react-icons/io';
import { BsArrowDown } from 'react-icons/bs';
import { BsArrowUp } from 'react-icons/bs';
import { BsArrowDownUp } from 'react-icons/bs';

import {
  deliveryAssignmentGetApi,
  DeliveryManagerType,
  keyMapping,
  orderListGetApi,
  orderListPostApi,
  OrderUploadResponseType,
  productionBetweenDaysGetApi,
  ProductionSimpleType,
  ProductItem,
  traderListGetApi,
  traderListPostApi,
  TraderType,
  WorkbayType,
} from '../../../api/apiConfig';
import useFetch from '../../../api/useFetch';
import { OrderUploadModal } from '../../common/modal/ModalComponents/OrderUploadModal';
//주문번호 예시 20241104-1

import { BsChevronDoubleLeft } from 'react-icons/bs';
import { BsChevronDoubleRight } from 'react-icons/bs';
import { BsChevronLeft } from 'react-icons/bs';
import { BsChevronRight } from 'react-icons/bs';

import {
  OrderListType,
  OrderListUpdateRequestDto,
} from '../../../api/apiConfig';
import { PaginationState } from '../Pagination';
import {
  formatCurrency,
  formatDashFormToEightDigitString,
  formatEightDigitStringToDashForm,
  formatEightDigitStringToSlashForm,
  getYearMonthDateFromDate,
} from '../../../function/replaceString';
import { groupOrderWithItemSubrow } from '../../../function/initData';
import { workbayIdToName } from '../../../@const/mapper';
import { DeliveryGroupType } from '../../../router/user/pages/DeliveryEditPage';
import { DeliveryTableGroupType } from '../../../router/user/pages/DeliveryListPage';

export type DeliveryTableProps = {
  data: OrderListType[];
};

export const DeliveryTable = ({ data }: DeliveryTableProps) => {
  const theme = useTheme();

  console.log('data', data);

  const [grouping, setGrouping] = useState<GroupingState>([]);

  const [selectedDeliveryGroup, setSelectedDeliveryGroup] = useState<
    OrderListType[]
  >([]);

  const [sorting, setSorting] = useState<SortingState>([]);

  //   const { fetch: fetchDeliveryAssignmentGetApi } = useFetch({
  //     fetchFunction: deliveryAssignmentGetApi,
  //     onSuccess: (data: DeliveryGroupType[]) => setDeliveryList(data),
  //   });

  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: 99999,
  });

  useEffect(() => {
    setGrouping(['assignmentDate']);
    setSelectedDeliveryGroup(data);
  }, [data]);

  //테이블 옵션값 ~~~
  const [headerOverflowType, setHeaderOverflowType] = useState<'wrap' | 'hide'>(
    'hide'
  );
  const [bodyOverflowType, setBodyOverflowType] = useState<'wrap' | 'hide'>(
    'hide'
  );
  const [bodyAlignHoriType, setBodyAlignHoriType] = useState<
    'left' | 'center' | 'right'
  >('left');

  const [cellHoriPaddValue, setCellHoriPaddValue] = useState<number>(5);
  const [bodyVertPaddValue, setBodyVertPaddValue] = useState<number>(5);

  const [showConfig, setShowConfig] = useState<boolean>(false);

  const columns = useMemo<ColumnDef<OrderListType>[]>(
    () => [
      {
        header: ({ table }) => <>No</>,
        cell: ({ row, getValue }) => {
          if (!row.getIsGrouped()) return null; // 그룹화되지 않은 행은 No 표시 안 함

          // 그룹화된 행들만 필터링
          const groupedRows = table
            .getSortedRowModel()
            .flatRows.filter((r) => r.getIsGrouped());

          // row 객체 참조 대신 row.id를 이용해 index 찾기
          const index = groupedRows.findIndex((r) => r.id === row.id);
          return (
            row.getIsGrouped() && (
              <Styled.NoBodyCell style={{ paddingLeft: `${row.depth * 2}rem` }}>
                <Styled.NoText>{index + 1}</Styled.NoText>
              </Styled.NoBodyCell>
            )
          );
        },
        id: 'NO',
        size: 60,
      },
      {
        header: '배송일자',
        accessorKey: 'assignmentDate',
        size: 118,
        cell: ({ row, getValue }) => {
          return (
            row.getIsGrouped() && (
              <Styled.NoBodyCell style={{ paddingLeft: `${row.depth * 2}rem` }}>
                <Styled.NoText>
                  {formatEightDigitStringToSlashForm(
                    row.original.assignmentDate as string
                  )}
                </Styled.NoText>
              </Styled.NoBodyCell>
            )
          );
        },
      },
      {
        header: '거래처명',
        accessorKey: 'CUST_DES',
        size: 280,
      },
      {
        header: '납기일',
        accessorKey: 'TIME_DATE',
        size: 118,
        cell: ({ row, getValue }) => {
          return (
            !row.getIsGrouped() && (
              <Styled.NoBodyCell>
                <Styled.NoText>
                  {formatEightDigitStringToSlashForm(
                    row.original.TIME_DATE as string
                  )}
                </Styled.NoText>
              </Styled.NoBodyCell>
            )
          );
        },
      },
      {
        header: '배송특이사항',
        accessorKey: 'deliveryRemarks',
        size: 200,
      },
      {
        header: '주소',
        accessorKey: 'receiverAddress',
        size: 240,
      },
      {
        header: '상세주소',
        accessorKey: 'receiverAddressDetail',
        size: 125,
      },
    ],
    []
  );

  //아마 페이지네이션
  function useSkipper() {
    const shouldSkipRef = useRef(true);
    const shouldSkip = shouldSkipRef.current;

    // Wrap a function with this to skip a pagination reset temporarily
    const skip = useCallback(() => {
      shouldSkipRef.current = false;
    }, []);

    useEffect(() => {
      shouldSkipRef.current = true;
    });

    return [shouldSkip, skip] as const;
  }

  const [autoResetPageIndex, skipAutoResetPageIndex] = useSkipper();
  //~~페이지네이션

  const table = useReactTable({
    data: selectedDeliveryGroup,
    columns,
    columnResizeMode: 'onChange',
    state: {
      expanded: true,
      pagination,
      sorting,
      grouping: grouping,
    },
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getExpandedRowModel: getExpandedRowModel(),
    getGroupedRowModel: getGroupedRowModel(),
    autoResetPageIndex,
    getPaginationRowModel: getPaginationRowModel(),
    paginateExpandedRows: false,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
  });

  const columnSizeVars = useMemo(() => {
    const headers = table.getFlatHeaders();
    const colSizes: { [key: string]: number } = {};
    for (let i = 0; i < headers.length; i++) {
      const header = headers[i]!;
      colSizes[`--header-${header.id}-size`] = header.getSize();
      colSizes[`--col-${header.column.id}-size`] = header.column.getSize();
    }
    return colSizes;
  }, [table.getState().columnSizingInfo, table.getState().columnSizing]);

  return (
    <>
      <Styled.TableContainer style={{ paddingTop: 0 }}>
        <Styled.TableDiv
          {...{
            style: {
              ...columnSizeVars,
              width: table.getTotalSize(),
            },
          }}
          $headOverflowType={headerOverflowType}
          $bodyOverflowType={bodyOverflowType}
          $bodyAlignHoriType={bodyAlignHoriType}
          $cellHoriPaddValue={cellHoriPaddValue}
          $bodyVertPaddValue={bodyVertPaddValue}
        >
          {table.getHeaderGroups().map((headerGroup) => {
            return (
              <Styled.ThDiv {...{ key: headerGroup.id }}>
                {headerGroup.headers.map((headerCell) =>
                  headerCell.isPlaceholder ? null : (
                    <Styled.ThCell
                      {...{
                        key: headerCell.id,
                        style: {
                          width: `calc(var(--header-${headerCell?.id}-size) * 1px)`,
                          cursor: headerCell.column.getCanSort()
                            ? 'pointer'
                            : 'auto',
                        },
                        // headerCell.column.getCanSort()
                        className: 'th',
                      }}
                    >
                      {headerCell.isPlaceholder
                        ? null
                        : flexRender(
                            headerCell.column.columnDef.header,
                            headerCell.getContext()
                          )}

                      {headerCell.column.getIsSorted() === 'asc' && (
                        <BsArrowDown
                          size={14}
                          style={{ marginLeft: '5px' }}
                          onClick={headerCell.column.getToggleSortingHandler()}
                        />
                      )}
                      {headerCell.column.getIsSorted() === 'desc' && (
                        <BsArrowUp
                          size={14}
                          style={{ marginLeft: '5px' }}
                          onClick={headerCell.column.getToggleSortingHandler()}
                        />
                      )}
                      {!headerCell.column.getIsSorted() &&
                        headerCell.column.getCanSort() && (
                          <BsArrowDownUp
                            size={14}
                            style={{ marginLeft: '5px' }}
                            onClick={headerCell.column.getToggleSortingHandler()}
                          />
                        )}

                      <Styled.ResizeHandler
                        {...{
                          onMouseDown: headerCell.getResizeHandler(),
                          className: `resizer ${
                            headerCell.column.getIsResizing()
                              ? 'isResizing'
                              : ''
                          }`,
                        }}
                      />
                    </Styled.ThCell>
                  )
                )}
              </Styled.ThDiv>
            );
          })}
          {table.getRowModel().rows.map((row) => (
            <>
              <Styled.TdDiv
                {...{
                  key: row.id,
                }}
              >
                {row.getVisibleCells().map((cell) => {
                  const isMainRow = row.depth === 0;

                  // 커스텀 스타일 (변경된 셀에 하이라이트 적용)
                  return (
                    <Styled.TdCell
                      {...{
                        key: cell.id,
                        className: 'td',
                        style: {
                          // 해당 셀이 변경되었으면 배경 색을 노란색으로 하이라이트
                          backgroundColor: isMainRow
                            ? theme.colors.white_odd
                            : 'transparent',
                          width: `calc(var(--header-${cell.column.id}-size) * 1px)`, // 셀 크기
                        },
                      }}
                    >
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}
                    </Styled.TdCell>
                  );
                })}
              </Styled.TdDiv>
            </>
          ))}
        </Styled.TableDiv>
      </Styled.TableContainer>
      {/* <Styled.PaginationButtonContainer>
          <Styled.PaginationButton
            size={28}
            onClick={() => table.firstPage()}
            disabled={!table.getCanPreviousPage()}
          >
            <BsChevronDoubleLeft />
          </Styled.PaginationButton>
          <Styled.PaginationButton
            size={28}
            onClick={() => table.previousPage()}
            disabled={!table.getCanPreviousPage()}
          >
            <BsChevronLeft />
          </Styled.PaginationButton>
          <Styled.PaginationButton
            size={28}
            onClick={() => table.nextPage()}
            disabled={!table.getCanNextPage()}
          >
            <BsChevronRight />
          </Styled.PaginationButton>
          <Styled.PaginationButton
            size={28}
            onClick={() => table.lastPage()}
            disabled={!table.getCanNextPage()}
          >
            <BsChevronDoubleRight />
          </Styled.PaginationButton>
        </Styled.PaginationButtonContainer> */}
      {/* <div
          style={{
            alignContent: 'center',
            marginLeft: '20px',
            marginRight: '40px',
          }}
        >
          {table.getPageCount()}페이지 중{' '}
          {table.getState().pagination.pageIndex + 1}페이지
        </div>
        <div className='flex-center'>페이지당 표시 데이터 수</div>
        <select
          id={'row-count'}
          value={pagination.pageSize}
          onChange={(e) => {
            setPagination((prev) => ({
              pageIndex: prev.pageIndex,
              pageSize: Number(e.target.value),
            }));
            table.firstPage();
          }}
          style={{ marginLeft: '14px' }}
        >
          <option key={'10'} value={10}>
            10개
          </option>
          <option key={'20'} value={20}>
            20개
          </option>
          <option key={'30'} value={30}>
            30개
          </option>
          <option key={'40'} value={40}>
            40개
          </option>
          <option key={'50'} value={50}>
            50개
          </option>
        </select> */}
    </>
  );
};
